import React from "react";

import queryString from "query-string";

import MainBodyTabs from "../common/MainBodyTabs";
import MainButton from "../common/MainButton";
import MainTitle from "../common/MainTitle";
import ProfileRoutes from "./Routes";
import useParityAccess, { useAccessReady } from "../common/useParityAccess";

import lbl from "../../data/Labels.json";

const StudentProfile = (props) => {
  const params = queryString.parse(props.location.search);
  const can = useParityAccess();
  const ready = useAccessReady();
  const allow = (key) => !ready || can(key);

  const tabs = [
    {
      name: "اطلاعات عمومی",
      path: `info`,
      urlParams: `stdName=${params.stdName}`,
    },
    {
      name: "حاضری",
      path: `attendance`,
      urlParams: `stdName=${params.stdName}`,
    },
    { name: "نتایج", path: `results`, urlParams: `stdName=${params.stdName}` },
    allow("view-student-fees")
      ? { name: "مالی", path: `fees`, urlParams: `stdName=${params.stdName}` }
      : null,
  ].filter(Boolean);

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainButton title={lbl.PrevPage} type={"back"} />
          <MainTitle title={params.stdName} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={tabs} {...props} />
        <ProfileRoutes {...props} />
      </div>
    </div>
  );
};

export default StudentProfile;
